
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class SuggestList extends Vue {
	@Prop({ default: "" })
	placeholder!: string

	@Prop({ default: [] })
	selectOptions!: string[]

	@Prop()
	value!: string

	@Prop({ default: "Create new" })
	createNewMessage!: string

	@Prop({ default: false })
	readonly!: boolean
}

